import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import CreateZone from './../createzone';
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../services/masterdata.service';
import Loader from '../../../../shared/components/loader';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';

export default {
  name: 'Zone-Listing',
  components: {
    BasicSelect,
    CreateZone,
    Pagination,
    CustomExpandableTable,
    VueElementLoading,
    Loader
  },
  props: [],
  data: function() {
    return {
      //for filter
      tableColumn: ['Territory ID', 'Territory Name', 'Region', 'Base City','Created By','Created Date','Status','Action'],
      innerTableColumn: [],
      tableItems: [],
      ZoneLoading: false,
      isLoading: false,
      fltzone: '',
      type: 'CARGO_ZONE_MASTER',
      fltzonename: '',
      regionlist: [],
      selectedfltregion: {
        text: '',
        value: ''
      },
      fltregion: '',
      statelist: [],
      selectedfltstate: {
        text: '',
        value: ''
      },
      fltstate: '',
      citylist: [],
      citydata: [],
      basecitylist: [],
      selectedfltcity: {
        text: '',
        value: ''
      },
      selectedfltbasecity: {
        text: '',
        value: ''
      },
      fltcity: '',
      fltbasecity: '',
      showlist: true,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset: 0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      citydata: [],
      viewdata: [],
      ViewZoneDetails: [],
      selectedZoneObj: [],
      tableArr: [],
      CityDataLoading: false,
      citydataByIdsArray: [],
      // offset: '',
      status:"",
      zoneidSearch: '',
      zonenameSearch: '',
      zoneregionSearch: '',
      stateSearch: '',
      basecitySearch: '',
      citySearch: '',
      statusSearch: '',
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
      stategroup:{}
    }
  },
  computed: {

  },
  mounted() {
    this.getAllCity();
    this.getStateList();
    this.getRegionList();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showAddForm() {
      this.showlist = false
      this.selectedZoneObj = []
    },
    callParent() {
      this.showlist = true;
      this.currentPage = 1;
      this.offset = 0;
      this.getZoneDetails();
    },
    searchZone(){
      this.currentPage = 1;
      this.offset = 0;
      this.zoneidSearch = this.fltzone;
      this.zonenameSearch = this.fltzonename;
      this.zoneregionSearch = this.selectedfltregion.text;
      this.stateSearch = this.selectedfltstate.value;
      this.basecitySearch = this.selectedfltbasecity.value;
      this.citySearch = this.selectedfltcity.value;
      this.statusSearch = this.status;
      this.getZoneDetails();
    },
    removeComma(displayValue){
      return String(displayValue).replace(/,/g, "");
    },
    async getBaseCityList(){
      this.basecitylist = []
      try {
        let result = await MasterService.getBaseCityList();
        let basecityslist = result.data.data;
        for (var i = 0; i < basecityslist.length; i++) {
          this.basecitylist.push({
            'value': basecityslist[i].cityid,
            'text': this.getCityName(basecityslist[i].cityid)
          })
        }
      } catch (err) {
        this.getZoneDetails();
        console.log(err);
      }
    },
    async getAllCity() {
      this.CityDataLoading = true;
      this.ZoneLoading = true;
      this.citydata = [];
      try {
        let result = await MasterService.getAllCity();
        this.citydata = result.data.data.data;
        for (var i = 0; i < this.citydata.length; i++) {
          this.citylist.push({
            'value': this.citydata[i].cityid,
            'text': this.citydata[i].cityname
          })
        }
        this.CityDataLoading = false;
        this.getBaseCityList();
        this.getZoneDetails();
      } catch (err) {
        this.CityDataLoading = false
        console.log(err);
      }
    },
    async getZoneDetails(type) {
      this.ZoneDetails = []
      this.ZoneLoading = true
      try {
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if (this.zoneidSearch != '') {
          inputPayload.zoneid = this.zoneidSearch.trim();
        }
        if (this.zonenameSearch != '') {
          inputPayload.zonename = this.zonenameSearch.trim();
        }
        if (this.zoneregionSearch != '') {
          inputPayload.region = this.zoneregionSearch;
        }
        if (this.stateSearch != '') {
          inputPayload.state = this.stateSearch;
        }
        if (this.basecitySearch != '') {
          inputPayload.basecity = this.basecitySearch;
        }
        if (this.citySearch != '') {
          inputPayload.city = this.citySearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }

        let result = await MasterService.getZoneDetails(inputPayload);
        this.tableArr = result.data.data.rows;
        this.ZoneLoading = false;
        this.totalCount = result.data.data.count.length;

        if(this.totalCount>0){
          this.tableArr = result.data.data.rows;
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'Territory ID':el.cargozoneid,
              'Territory Name': el.cargozonename,
              'Region': el.master_region,
              'Base City': this.getCityName(el.base_city),
              'Created By':el.createdby,
              'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Status': el.status,
              'Action': 'Need To Check1'
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch (err) {
        this.ZoneLoading = false;
        console.log(err);
      }
    },
    async getCitiesByIds(cityid) {
      this.citydataByIdsArray = []
      try {
        let inputPayload = {
          "cityId": [cityid]
        }
        let result = await MasterService.getCitiesByIds(inputPayload)
        this.citydataByIdsArray = result.data.data
        this.citydataByIdsArray.map((cityObj)=>{
          let obj = this.statelist.find(obj => obj.value == cityObj.stateid);
          if(obj){
            return obj.text
          }
        }).join(", ")
      } catch (err) {
        console.log(err);
      }
    },
    viewData(data, ind) {
      const index = this.viewdata.indexOf(ind);
      if (index > -1) {
        this.viewdata.splice(index, 1)
      } else {
        this.viewdata = [];
        this.viewdata.push(ind)
      }
    },
    getBaseCityName(basecity) {
      for (var i = 0; i < this.citydata.length; i++) {
        if (this.citydata[i].cityid == basecity) {
          return this.citydata[i].cityname;
        }
      }
    },
    getStateName(state) {
      for (var i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].value == state) {
          return this.statelist[i].text;
        }
      }
    },
    getCityName(city) {
      for (var i = 0; i < this.citydata.length; i++) {
        if (this.citydata[i].cityid == city) {
          return this.citydata[i].cityname;
        }
      }
    },
    showBaseCityName(city) {
      if(this.basecitylist.length > 0){
        for (var i = 0; i < this.basecitylist.length; i++) {
          if (this.basecitylist[i].value == city) {
            return this.basecitylist[i].text;
          }
        }
      }else{
        return city;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getZoneDetails();
    },
    getCustomTableEvent(event) {
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType=="edit"){
        let selectedZoneObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedZoneObj = selectedZoneObj[0];
        this.showlist = false;
      }else if(event.actionType=="view"){
        this.getZoneDetailsById(event.id);
      }
    },
    async getZoneDetailsById(zoneid){
      try {
        let InputPayload = {
          zoneid: zoneid
        }
        this.isLoading = true;
        let response = await MasterService.getZoneDetailsById(InputPayload);
        this.ViewZoneDetails = response.data.data;
        this.ViewZoneDetails.stategroup = {};
        this.stategroup = this.groupBy(this.ViewZoneDetails.cargozonestatecities, 'statename');
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    getCitiesName(data){
      let tempArr = [];
      data.forEach(function(item){
        tempArr.push(item.cityname);
      });
      return tempArr.join(", ");
    },
    groupBy(array, property) {
      var hash = {};
      let tempArr = [];
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    async activeAction(data){
      try {
        this.ZoneLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Territory  Activated Successfully!!", this.fltzonename, "success");
        }else{
          this.$alert("Territory Inactivated Successfully!!", this.fltzonename, "success");
         }
          this.getZoneDetails();
          this.ZoneLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    async getRegionList() {
      var regionlist = []
      try {
        let result = await MasterService.getRegionList()
        regionlist = result.data.data
        for (var i = 0; i < regionlist.length; i++) {
          this.regionlist.push({
            'text': regionlist[i].region
          })
        }
      } catch (err) {
        console.log(err);var isactivestatus = data.IsActive == 0 ? 1 : 0
      }
    },
    selectFltRegion(selectedfltregion) {
      this.selectedfltregion = selectedfltregion
      this.fltregion = selectedfltregion.text
    },
    async getStateList() {
      var stateregionlist = []
      try {
        let result = await MasterService.getStateList()
        stateregionlist = result.data.data
        for (var i = 0; i < stateregionlist.length; i++) {
          this.statelist.push({
            'value': stateregionlist[i].stateid,
            'text': stateregionlist[i].statename
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectFltState(selectedfltstate) {
      this.selectedfltstate = selectedfltstate
      this.fltstate = selectedfltstate.text
      this.citylist = []
      this.selectedfltcity = {
        text: '',
        value: ''
      }
      this.fltcity = ''
      if (this.fltstate != '') {
        this.getCityList(selectedfltstate.value)
      }
    },
    selectFltbaseCity(selectedfltbasecity) {
      this.selectedfltbasecity = selectedfltbasecity
      this.fltbasecity = selectedfltbasecity.text
    },
    selectFltCity(selectedfltcity) {
      this.selectedfltcity = selectedfltcity
      this.fltcity = selectedfltcity.text
    },
    async getCityList(stateid) {
      var citystateregionlist = []
      try {
        let inputPayload = {
          "stateId": [stateid]
        }
        let result = await MasterService.getCityList(inputPayload)
        citystateregionlist = result.data.data
        for (var i = 0; i < citystateregionlist.length; i++) {
          this.citylist.push({
            'value': citystateregionlist[i].cityid,
            'text': citystateregionlist[i].cityname
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    resetSearchForm() {
      this.fltzone = '';
      this.fltzonename = '';
      this.fltregion = '';
      this.status= "";
      this.selectedfltregion = {
        value: '',
        text: ''
      }
      this.fltstate = '';
      this.selectedfltstate = {
        value: '',
        text: ''
      }
      this.fltcity = '';
      this.selectedfltcity = {
        value: '',
        text: ''
      }
      this.fltbasecity = '';
      this.selectedfltbasecity = {
        value: '',
        text: ''
      }
      this.zoneidSearch = '';
      this.offset = 0;
      this.zonenameSearch = '';
      this.zoneregionSearch = '';
      this.stateSearch = '';
      this.basecitySearch = '';
      this.citySearch = '';
      this.statusSearch = '';
      this.statusitem = {};
      this.ZoneDetails = [];
      this.currentPage = 1;
      this.getZoneDetails();
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/zone/zonelisting/zonelisting.component.js